<template>
  <div>
    <div class="bet-slip">
      <div class="bet-slip-content">
        <div class="mt-2 mb-2">
          <div style="padding: 1px;">
            <div class="text-white p-2 position-relative bet-slip-options load">
              <div class="text-center">Straight</div>
            </div>
          </div>
        </div>

        <div
          class="bet-slip-item-wrapper bg-white bet-slip-selection position-relative d-flex"
          v-for="(n, i) in betCount"
        >
          <div class="checkbox-wrapper" v-if="showCheckbox">
            <div class="form-control bet-slip-form-control border-0 load"></div>
          </div>
          <div class="w-100 pl-1">
            <div class="bet-slip-line-subheader m-0 bg-white">
              <h1 class="title bold-title load mb-o pb-0" style="margin: 0 !important;">
                Sample Team
              </h1>
            </div>
            <div class="bet-slip-line p-0 pt-1">
              <div class="form-control bet-slip-form-control mr-2 border-0 load"></div>
              <div class="form-control bet-slip-form-control border-0 load"></div>
            </div>
          </div>
        </div>

        <div class="bg-white mt-1">
          <div class="bet-slip-line-subheader bg-white">
            <h1 class="title bold-title load">Total Bets</h1>
            <h1 class="title bold-title load">0000</h1>
          </div>
          <div class="ml-2 mr-2 mb-2 d-flex justify-content-center">
            <button class="btn place-bet-btn btn-orange load w-75">
              <span>Place Bet</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BetSlipMixin from './bet-slip-mixin';

export default {
  mixins: [BetSlipMixin],
  props: {
    betCount: {
      type: Number,
      default: 0,
    },
  },
};
</script>

<style scoped></style>
